export enum Variant {
  Success = "Success",
  Warning = "Warning",
  Danger = "Danger",
}
